import { conversionStatusTypes } from '../../../shared/enums/conversionStatusTypes';
import { mediaContentTypes } from '../../../shared/enums/mediaContentTypes';
import { mediaTypes } from '../../../shared/enums/mediaTypes';
import { ScanningStatusEnum } from '../../../shared/enums/scanningStatus.enum';
import { AttachmentFile } from '../../../shared/models/attachmentFile.model';
import { MediaModel } from '../../../shared/models/media.model';
import { SimpleFile } from '../../../shared/models/responses/file/file.response';
import { SearchMediaResult } from '../../../shared/models/responses/search/findGeneric.response';

function mapSimpleFileToAttachmentFile(file: SimpleFile): AttachmentFile {
  const { id, scanningStatus, ...rest } = file;
  return {
    ...rest,
    attachedSecureDocumentId: id,
    shareableGuardianIds: [],
    isLargeFile: false,
    scanningStatus: scanningStatus ?? ScanningStatusEnum.AVAILABLE,
  };
}

/**
 * Builds a {@link MediaModel} from generic search media hits.
 * Several fields are absent from {@link SearchMediaResult}.
 */
export function mapSearchMediaResultToMediaModel(result: SearchMediaResult): MediaModel {
  const {
    mediaType,
    file,
    tags,
    title,
    conversionStatus,
    thumbnailUrl,
    extraSmallThumbnailUrl,
    smallThumbnailUrl,
    mediumThumbnailUrl,
    largeThumbnailUrl,
  } = result;

  return {
    mediaType: mediaType as mediaTypes,
    contentType: mediaContentTypes.SITUATION,
    file: mapSimpleFileToAttachmentFile(file),
    tags,
    extraSmallThumbnailUrl: extraSmallThumbnailUrl ?? '',
    smallThumbnailUrl: smallThumbnailUrl ?? '',
    mediumThumbnailUrl: mediumThumbnailUrl ?? '',
    largeThumbnailUrl: largeThumbnailUrl ?? '',
    thumbnailUrl: thumbnailUrl ?? '',
    conversionStatus: conversionStatus ?? conversionStatusTypes.COMPLETED,
    title: title ?? undefined,
    hasVideoThumbnail: Boolean(largeThumbnailUrl),
  };
}
